import { styled } from '@/stitches.config';
import { Box, Button, Form, FormField, SelectA11y } from '@base-app';

export const FormStyled = styled(Form, { display: 'flex', flexWrap: 'wrap' });

export const FormFieldStyled = styled(FormField, {
  flexBasis: '100%',
  '@sm': {
    flexBasis: '50%',
  },
});

export const FormFieldRoleStyled = styled(FormField, {
  flexBasis: '100%',
  '@sm': {
    flexBasis: '30%',
    flexGrow: '1',
  },
});

export const SelectStyled = styled(SelectA11y, {
  width: '60%',
});

export const ButtonStyled = styled(Button, {
  ml: '$4',
  flexGrow: '1',
  '@sm': {
    flexGrow: 'auto',
  },
});

export const FormButtonsStyled = styled(Box, {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  '@sm': {
    width: 'auto',
  },
});
